<template>
  <div style="padding: 10px 20px; min-height: calc(100vh - 168px);">
    <header>
      <h2>{{ details.title }}</h2>
      <h4>{{ details.subTitle }}</h4>
      <div>
        <span>题目数: {{ details.subjectCount }}</span>
        <span>时长: {{ details.exceptTime }}</span>
        <span>价格: {{ details.price }}</span>
        <span>专业价格: {{ details.majorPrice }}</span>
      </div>
    </header>
    <main>
      <div>
        <img :src="details.exhibitImg" style="max-width: 800px;"/>
      </div>
      <div>{{ details.briefDesc }}</div>
      <div>
        <section v-for="subject in subjects" :key="subject.id">
          <div>
            ({{ subject.index }}). {{ subject.title }}
            <mark>{{ subject.subjectType | subjectTypeFmt }}</mark>
          </div>
          <div v-if="subject.subjectType != 4 && subject.subjectType != 5">
            <p v-for="optionItem in subject.options" :key="optionItem.id">
              {{ optionItem.title }} ({{ optionItem.score }}分)
            </p>
          </div>
        </section>
      </div>
    </main>
    <div class="res">
      <h4>分析结果</h4>
      <hr>
      <p v-for="analysis in analyses" :key="analysis.id">
        <span class="res-range">({{ analysis.scoreRangeMin }} - {{ analysis.scoreRangeMax }})</span>
        <span class="res-title">{{ analysis.title }}</span>
        <span class="res-desc">{{ analysis.analysisDesc }}</span>
      </p>
    </div>

    <div>
      <h4>评论列表</h4>
      <hr>
      <div v-for="msg in msgPage.rows" :key="msg.id" class="msg-list">
        <p>
          <span class="msg-user"><el-avatar :size="30" icon="el-icon-user-solid"></el-avatar>{{ msg.userName }}</span>
          <span class="msg-time">{{ msg.msgDate }}</span>
          <span :data-state="msg.status" @click="showStatusDialog(msg.id)">{{ msg.status | statusFmt }}</span>
        </p>
        <p>{{ msg.msgContent }}</p>
      </div>

      <el-pagination
          class="pagination"
          :hide-on-single-page="true"
          background
          prev-text="Prev"
          next-text="Next"
          @current-change="skipMsgPage"
          :current-page="msgPage.current"
          :page-size="msgPage.size"
          layout="prev, pager, next"
          :total="msgPage.total">
      </el-pagination>


    </div>

    <el-dialog :visible.sync="statusDialog"
               title="修改状态"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="300px">
      <el-radio-group v-model="msg.status">
        <el-radio label="1">正常</el-radio>
        <el-radio label="2">精选</el-radio>
        <el-radio label="3">封禁</el-radio>
      </el-radio-group>
      <div style="margin-top: 10px">
        <el-input type="textarea" :rows="4" v-model="msg.reason" placeholder="原因"></el-input>
      </div>
      <template slot="footer">
        <el-button style="width: 80px;padding: 8px;" type="primary" @click="changeStatus">保存</el-button>
        <el-button style="width: 80px;margin-left: 20px;padding: 8px;" @click="statusDialog=false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import base from '@/api/common';
import qs from 'qs';

export default {
  name: "exam_details",
  data() {
    return {
      id: this.$route.params.id,
      details: {},
      subjects: [],
      analyses: [],
      msgPage: {
        current: 1,
        size: 15,
        total: 9,

        rows: []
      },

      statusDialog: false,

      msg: {
        id: '',
        status: '1',
        reason: ''
      }
    }
  },

  mounted() {
    if (!this.id) {
      return;
    }
    // 加载details数据
    this.$ajax.get(base.manager_api.exam.details.replace("{id}", this.id)).then(res => {
      if (res.data.status === 'success') {
        this.details = res.data.data;
      } else {
        this.$message.error("信息加载失败");
      }
    });
    // 加载题目信息
    this.$ajax.post(base.manager_api.exam.subjects.replace("{id}", this.id)).then(res => {
      if (res.data.status === 'success') {
        this.subjects = res.data.list;
      } else {
        this.$message.error("信息加载失败");
      }
    });
    // 加载系统分析结果信息
    this.$ajax.get(base.api.exam.analysis.replace("{id}", this.id)).then(res => {
      if (res.data.status === 'success') {
        this.analyses = res.data.list;
      } else {
        this.$message.error("信息加载失败");
      }
    });
    // 加载评论列表
    this.skipMsgPage(1);

  },
  methods: {
    skipMsgPage(current) {
      this.msgPage.current = current;
      this.$ajax.get(base.manager_api.exam.message.page.replace("{id}", this.id), {
        params: {
          page: this.msgPage.current,
          size: this.msgPage.size
        }
      }).then(res => {
        if (res.data.status === 'success') {
          this.msgPage.current = res.data.current;
          this.msgPage.size = res.data.size;
          this.msgPage.total = res.data.total;
          this.msgPage.rows = res.data.rows;
        } else {
          this.$message.error("信息加载失败");
        }
      })
    },
    showStatusDialog(id) {
      if (id) {
        this.statusDialog = true;
        this.msg.id = id;
      }
    },
    changeStatus() {
      let id = this.msg.id;
      let reason = this.msg.reason;
      let status = this.msg.status;
      let that = this;
      if (status == 3 && $.trim(reason).length === 0) {
        this.$message.warning("封禁时原因必填");
        return;
      }
      this.$ajax.post(base.manager_api.exam.message.changeStatus.replace("{id}", id), qs.stringify({
        status: status,
        reason: reason
      })).then(res => {
        if (res.data.status === 'success') {
          // 更改状态
          that.statusDialog = false;
          that.msg.id = '';
          that.msg.reason = '';
          that.$message.success("操作成功");
          $(that.msgPage.rows).each((i, o) => {
            if (o.id == id) {
              o.status = status;
              return false;
            }
          })
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    }
  },
  filters: {
    subjectTypeFmt(type) {
      if (type) {
        type = Number(type);
        switch (type) {
          case 1:
            return '单选题';
          case 2:
            return '判断题';
          case 3:
            return '多选题';
          case 4:
            return '填空题';
          case 5:
            return '问答题';
        }
      }
      return '';
    },
    statusFmt(status) {
      if (status) {
        status = Number(status);
        switch (status) {
          case 1:
            return '正常';
          case 2:
            return '精选';
          case 3:
            return '封禁';
        }
      }
      return '';
    }
  },

}
</script>

<style scoped>

section {
  margin: 20px 0
}

mark {
  font-size: 12px
}

.res-range {
  font-size: 16px;
  color: #7e7e7e
}

.res-title {
  font-size: 18px;
  color: #111;
  margin-right: 20px;
}

.res-desc {
  font-size: 14px;
}

.res p {
  margin: 16px 0
}

.msg-list {
  margin: 10px 0
}

.msg-user {
  font-size: 16px;
  font-weight: 900;
  margin-right: 10px
}

.msg-time {
  font-size: 12px
}

span[data-state] {
  cursor: pointer
}

span[data-state='1'] {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

span[data-state='2'] {
  color: #409EFF;
  background-color: #d9ecff;
  border-color: #d9ecff;
}

span[data-state='3'] {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2;
}


</style>